export const htmlContentStyles = {
  fontFamily: "inherit",
  fontSize: "0.875rem !important",
  "& p": {
    marginBottom: "1rem",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& br": {
    display: "block",
    content: '""',
    marginBottom: "0.5rem",
  },
  "& ol, & ul": {
    marginBottom: "1rem",
    paddingLeft: "1.5rem",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& ol": {
    listStyleType: "decimal",
    listStylePosition: "outside",
  },
  "& ul": {
    listStyleType: "disc",
    listStylePosition: "outside",
  },
  "& li": {
    marginBottom: "0.5rem",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "& blockquote": {
    marginLeft: "1rem",
    paddingLeft: "1rem",
    borderLeft: "3px solid",
    borderColor: "grey.300",
    fontFamily: "SourceSerif4",
    fontWeight: 500,
    fontStyle: "italic",
  },
  "& strong, & b": {
    fontWeight: "700 !important",
    display: "inline !important",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    textRendering: "optimizeLegibility",
  },
  "& h1, & h2, & h3, & h4, & h5, & h6": {
    fontWeight: "bold !important",
    display: "inline !important",
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    textRendering: "optimizeLegibility",
  },
  // KaTeX math styling
  "& .katex": {
    fontSize: "1em",
  },
  "& .katex-display": {
    margin: "1rem 0",
    textAlign: "center",
  },
  "& .katex-display > .katex": {
    display: "inline-block",
    textAlign: "left",
  },
};

// Utility function to check if HTML content is empty or only contains whitespace
export const isHtmlContentEmpty = (html: string): boolean => {
  const withoutTags = html.replace(/<[^>]*>/g, "");
  return !withoutTags.trim();
};
